<template>
    <div>
        <h2>
            {{ 'tours.title' | trans }}
        </h2>
        <ul>
            <li>
                <div class="datepicker-container">
                    <label class="gl noselect">{{ 'tours.pickDay' | trans }}</label>
                    <date-picker
                        v-model="pickday"
                        format="dd/MM/yyyy"
                        :lang="lang"
                        :not-before="now"
                    />
                </div>
                <gl-input
                    :placeholder="'tours.pickpoint' | trans"
                    v-model="pickPoint"                    
                >
            </li>
            <li>
                <button
                    class="btn red"
                    @click="cancel"
                >
                    {{ 'rent.cancel' | trans }}
                </button>
                <button
                    class="btn"
                    @click="selected"
                >
                    {{ 'rent.accept' | trans }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import date from 'date-and-time';
import { isEmpty } from 'ramda';

import GlInput from '../groovielize/components/TextInput';

export default {
    name: 'rent',
    data() {
        return {
            pickday: '',
            pickPoint: '',
            lang: document.documentElement.lang
        };
    },
    computed: {
        now() {
            return Date.now();
        }
    },
    methods: {
        selected () {    
            let start = this.pickday;
            if(isEmpty(start)) {
                start = new Date();
            }
            
            this.$emit('select', {
                start: date.format(start, 'DD/MM/YYYY'),
                pickPoint: this.pickPoint
            });
        },
        cancel() {
            this.pickday = '';
            this.pickPoint = '';
            this.$emit('select', null);
        }
    },
    components: {
        DatePicker,
        GlInput
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Tours.vue